(()=>{
  'use strict';
  if(window.__t21Global)return;
  window.__t21Global=true;
  const menu=()=>document.getElementById('t21-navigation');
  function positionMenu(){
    if(!menu()?.open)return;
    const header=document.querySelector('.t21-header');
    if(!header)return;
    const height=window.visualViewport?.height||window.innerHeight;
    const top=Math.max(12,Math.min(header.getBoundingClientRect().bottom+8,height-200));
    document.documentElement.style.setProperty('--t21-menu-top',Math.round(top)+'px');
  }
  function updateMenu(resetScroll=false){
    const navigation=menu();
    if(!navigation)return;
    navigation.querySelector(':scope > summary')?.setAttribute('aria-label',navigation.open?'Menü schließen':'Menü öffnen');
    if(navigation.open){
      if(resetScroll)navigation.querySelector('.t21-navigation-panel').scrollTop=0;
      positionMenu();
    }else{
      navigation.querySelectorAll('details[open]').forEach(detail=>{detail.open=false;});
    }
  }
  // The storefront is light-only, including visitors with a previously saved dark preference.
  document.documentElement.dataset.theme='light';
  try{localStorage.removeItem('t21-store-theme');}catch{}
  updateMenu();
  document.addEventListener('click',event=>{
    const navigation=menu();
    if(navigation?.open&&(!navigation.contains(event.target)||event.target.closest('a')))navigation.open=false;
  });
  document.addEventListener('toggle',event=>{
    if(event.target.id==='t21-navigation')updateMenu(event.target.open);
    // Native exclusive <details name> plus a fallback for older in-app browsers.
    if(event.target.matches?.('.t21-home .faq-list details[open]')){
      event.target.closest('.faq-list').querySelectorAll('details[open]').forEach(detail=>{
        if(detail!==event.target)detail.open=false;
      });
    }
  },true);
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const navigation=menu();
    if(!navigation?.open)return;
    const nested=event.target.closest('.t21-nav-group[open]');
    const target=nested||navigation;
    target.open=false;
    target.querySelector('summary')?.focus();
    event.preventDefault();
  });
  window.addEventListener('resize',positionMenu,{passive:true});
  window.visualViewport?.addEventListener('resize',positionMenu,{passive:true});
  document.addEventListener('shopify:section:load',()=>{updateMenu();});
})();
